import PopupCancelArrangement from './popup-cancel-arrangement';

export default PopupCancelArrangement;
